module.exports = __webpack_public_path__ + "img/生鲜进口商品.86567d12.png";